import theme from "@configs/theme";
import { events } from "@constants/tracking";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import { trackCustomEvent } from "analytics";
import { useEffect } from "react";
import { PaperProvider } from "react-native-paper";
import type { ThemeProp } from "react-native-paper/lib/typescript/types";
import E6BCalculator from "./E6BCalculator";

const FlightCalculatorDialog = ({
	dialogVisible,
	hideDialog,
}: {
	dialogVisible: boolean;
	hideDialog: () => void;
}) => {
	const finalTheme = theme(true);

	useEffect(() => {
		if (dialogVisible) {
			trackCustomEvent({
				eventName: events.dialogOpened,
				type: "flight-calculator",
			});
		}
	}, [dialogVisible]);

	const handleClose = () => {
		hideDialog();
		trackCustomEvent({
			eventName: events.dialogClosed,
			type: "flight-calculator",
		});
	};
	return (
		<>
			<DialogWrapper
				visible={dialogVisible}
				handleClose={handleClose}
				showCloseButton={false}
				height="80%"
				maxWidth={"xs"}
			>
				<PaperProvider theme={finalTheme as unknown as ThemeProp}>
					<E6BCalculator />
				</PaperProvider>
			</DialogWrapper>
		</>
	);
};

export default FlightCalculatorDialog;
